
<template>
  <div>
    <v-row>
      <v-col cols="3">
        <div class="item-title">
          {{ local.judicialFees.objection.code }}
        </div>
        <div class="item-value">
          {{ bill.objectionRequestCode }}
        </div>
      </v-col>
      <v-col cols="3">
        <div class="item-title">
          {{ local.judicialFees.objection.status }}
        </div>
        <div class="item-value">
          {{ bill.objectionStatus }}
        </div>
      </v-col>
      <v-col
        cols="6"
        class="text-left"
      >
        <div
          class="clickable"
          @click="expandObjectionRequest(!isObjectionExpand)"
        >
          <span class="item-title">
            {{ local.judicialFees.objection.details }}
          </span>
          <v-icon v-if="!isObjectionExpand">
            mdi-chevron-double-down
          </v-icon>
          <v-icon v-if="isObjectionExpand">
            mdi-chevron-double-up
          </v-icon>
        </div>
      </v-col>
      <v-col v-if="isObjectionExpand && objectionRequest">
        <v-col cols="12">
          <div class="item-title">
            {{ local.judicialFees.objection.customer }}
          </div>
          <div class="item-value">
            {{ objectionRequest.customerName }}
          </div>
        </v-col>
        <v-col cols="12">
          <div class="item-title">
            {{ local.judicialFees.objection.creationDate }}
          </div>
          <div class="item-value">
            {{ formatGeorgianEnDateString(objectionRequest.creationDate) }}
          </div>
        </v-col>
        <v-col :cols="!objectionRequest.objectionReasonId?6:12">
          <div class="item-title">
            {{ local.judicialFees.objection.reason }}
          </div>
          <div class="item-value">
            {{ objectionRequest.objectionReasonName || local.judicialFees.other }}
          </div>
        </v-col>
        <v-col
          v-if="objectionRequest.otherObjectionReason && !objectionRequest.objectionReasonId"
          cols="6"
        >
          <div class="item-title">
            {{ local.judicialFees.objection.reasonText }}
          </div>
          <div class="item-value">
            {{ objectionRequest.otherObjectionReason }}
          </div>
        </v-col>
        <v-col
          v-if="objectionRequest.objectionDetails"
          cols="12"
        >
          <div class="item-title">
            {{ local.judicialFees.objection.details }}
          </div>
          <div class="item-value">
            {{ objectionRequest.objectionDetails }}
          </div>
        </v-col>
        <v-col :cols="12">
          <div class="item-title">
            {{ local.judicialFees.objection.attachments }}
          </div>
          <div
            v-for="(attachment,index) in objectionRequestAttachments"
            :key="index"
            class="item-value clickable"
            @click="viewAttachment(attachment)"
          >
            <v-icon color="primary">
              mdi-eye
            </v-icon>
            <span>
              {{ attachment.fileName }}
            </span>
          </div>
          <div
            v-if="objectionRequestAttachments.length==0"
            :key="index"
            class="item-value"
          >
            <span>
              {{ local.judicialFees.objection.noAttachments }}
            </span>
          </div>
        </v-col>
        <v-col
          v-if="objectionRequest.decisionMakerNotes"
          :cols="12"
        >
          <div class="item-title">
            {{ local.judicialFees.objection.decision }}
          </div>
          <div class="item-value">
            {{ objectionRequest.decisionMakerNotes }}
          </div>
          <div
            v-if="decisionAttachment"
            class="item-value clickable"
            @click="viewAttachment(decisionAttachment)"
          >
            <v-icon color="primary">
              mdi-eye
            </v-icon>
            {{ local.judicialFees.objection.decisionAttachment }}
          </div>
        </v-col>
      </v-col>
    </v-row>
    <pdf-modal
      v-if="selectedFile"
      ref="pdfModal"
      :file-name="selectedFile.fileName"
      :share-point-id="selectedFile.sharePointId"
      @modalClose="hideViewAttachmentModal"
    >
    </pdf-modal>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapJudicialFeesActions } = createNamespacedHelpers('JudicialFeesModule');
import { formatGeorgianEnDateString } from '@/helpers/utils';
import { attachmentTypes } from '@/modules/judicialFees/helpers/enum';
import PdfModal from '@/components/shared/pdf-modal/index.vue';

export default {
  name: 'ObjectionRequestInfo',
  components: { PdfModal },
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formatGeorgianEnDateString,
      isObjectionExpand: false,
      objectionRequest: null,
      selectedFile: null,
      isLoading: false,
      attachmentTypes,
    };
  },
  computed: {
    decisionAttachment() {
      return (this.objectionRequest.attachments || []).find(a => a.typeId == this.attachmentTypes.decision);
    },
    objectionRequestAttachments() {
      return (this.objectionRequest.attachments || []).filter(a => a.typeId != this.attachmentTypes.decision);
    },
  },
  watch: {},
  mounted() { },
  methods: {
    ...mapJudicialFeesActions(
      [
        'getObjectionRequest',
      ]
    ),
    loadData() {
      if (!this.objectionRequest) {
        const objectKey = this.bill.objectionRequestObjectKey;
        this.getObjectionRequest(objectKey)
          .then((results) => {
            this.objectionRequest = results.data;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    expandObjectionRequest(value) {
      this.isObjectionExpand = value;
      if (value) {
        this.loadData();
      }
    },
    viewAttachment(attachment) {
      this.selectedFile = attachment;
      this.$nextTick(() => {
        var modal = this.$refs.pdfModal;
        modal.showModal();
      });
    },
    hideViewAttachmentModal() {
      this.selectedFile = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}
.item-title {
  font-size: 14px;
  font-weight: bold;
  color: var(--app-primary-color);
}

.item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}
</style>
